import React from 'react'
import { Drawer, List, makeStyles, Typography } from '@material-ui/core'
import DraggableListItem from '../Atoms/DraggableListItem'
import DnDItemTypes from '../../features/dnd/DnDItemTypes'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    flexShrink: 0,
  },
  list: {
    minWidth: '220px',
  },
  toolbar: {
    ...theme.mixins.toolbar,
    marginTop: '100px',
  },
  typeTitle: {
    paddingLeft: '20px',
    fontWeight: 'bold',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}))

export const QuestionTypesMenu = ({ items }) => {
  const classes = useStyles()

  return (
    <Drawer className={classes.drawer} variant='permanent' anchor='right'>
      <div className={classes.toolbar} />
      <Typography variant='h6' className={classes.typeTitle}>
        Types
      </Typography>
      <List className={classes.list}>
        {items.map((item) => (
          <DraggableListItem
            key={item.label}
            item={item}
            type={DnDItemTypes.QUESTION_TYPE}
          />
        ))}
        <div className={classes.toolbar} />
      </List>
    </Drawer>
  )
}
